// extracted by mini-css-extract-plugin
export default {"addUser":"user-administration-manage-users-page_addUser","settingsCard":"user-administration-manage-users-page_settingsCard"};